import { env } from '@/lib/env';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';

// Devtools só em dev — não vai pro bundle de prod.
const TanStackRouterDevtools = env.IS_DEV
  ? lazy(() =>
      import('@tanstack/react-router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      })),
    )
  : () => null;

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {env.IS_DEV && (
        <Suspense fallback={null}>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  );
}

function NotFoundComponent() {
  return (
    <div className="grid min-h-screen place-items-center bg-bg p-6 text-fg">
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-semibold">404 — rota não encontrada</h1>
        <p className="text-fg-muted">
          Verifica o link. Se o problema persistir, abre a paleta com ⌘K e busca a tela.
        </p>
        <a
          href="/"
          className="inline-block rounded-md bg-accent px-4 py-2 text-accent-fg hover:bg-accent-hover"
        >
          Voltar pro início
        </a>
      </div>
    </div>
  );
}
